<template>
  <div class="modal notification-modal" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
       role="dialog"
       style="display:block; background-color:rgba(255, 255, 255, 0.6);">
    <div class="modal-dialog-centered modal-base">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">공지사항 {{ pageType == 'detail' ? '상세' : '수정' }}</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">
            <div class="info-div" style="overflow-x:auto;">
                <table class="info-table">
                    <colgroup>
                        <col width="12%">
                        <col width="88%">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>제목</th>
                            <td>
                                <input class="form-control" v-model="resultParams.title" :disabled="pageType == 'detail'">
                            </td>
                        </tr>
                        <tr>
                            <th>기간</th>
                            <td>
                            <input class="form-control" type="datetime-local" id="postEdDay"
                                v-model="resultParams.postEdDay" 
                                :disabled="pageType == 'detail'"
                                @change="()=>{changeTime = true}"
                                min="2000-01-01T00:00" max="2999-12-31T23:59"/>
                            <p style="margin:0 5px; color:red"
                                v-if="( resultParams.postEdDay != undefined ) && dateCheck() && changeTime"
                            >
                                공지기간 수정 시, {{changeFormat(timeOut, 'YYYY-MM-DD HH:mm')}} 이후 날짜/시간만 선택 가능합니다.
                            </p>
                            </td>
                        </tr>
<!--                        <tr>-->
<!--                            <th>지역</th>-->
<!--                            <td>-->
<!--                                <div class="region-list" id="region_list" >-->
<!--                                    <div>-->
<!--                                        <input type="checkbox" id="selectAll" -->
<!--                                          @change="changeCheckedAll($event.target.checked)" -->
<!--                                          :disabled="pageType == 'detail'"-->
<!--                                        />-->
<!--                                        <label for="selectAll">&nbsp; 전체선택</label>-->
<!--                                    </div>-->
<!--                                    <div class="region-select" v-for="(region, index) in regionList" :key="index">-->
<!--                                        <input type="checkbox" :id="'region_'+index" -->
<!--                                          :value="region" :name="region" -->
<!--                                          @change="changeChecked($event.target.checked, region)"-->
<!--                                          :disabled="pageType == 'detail'"-->
<!--                                        />-->
<!--                                        <label :for="'region_'+index">&nbsp; {{ region }}</label>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </td>-->
<!--                        </tr>-->
                        <tr>
                          <th>지역</th>
                          <td>
                            <div class="region-list-wrapper">
                              <!-- 접기/펼치기 버튼 -->
                              <button type="button" @click="toggleRegionList">
                                {{ showRegionList ? '▲ 닫기' : '▼ 지역 상세' }}
                              </button>

                              <!-- 지역 리스트 -->
                              <div
                                  class="region-list"
                                  id="region_list"
                                  v-show="showRegionList"
                              >
                                <div>
                                  <input type="checkbox" id="selectAll"
                                         @change="changeCheckedAll($event.target.checked)"
                                         :disabled="pageType == 'detail'"
                                  />
                                  <label for="selectAll">&nbsp; 전체선택</label>
                                </div>

                                <div class="region-select"
                                     v-for="(region, index) in regionList"
                                     :key="index"
                                >
                                  <input type="checkbox"
                                         :id="'region_'+index"
                                         :value="region"
                                         :name="region"
                                         @change="changeChecked($event.target.checked, region)"
                                         :disabled="pageType == 'detail'"
                                  />
                                  <label :for="'region_'+index">&nbsp; {{ region }}</label>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                            <th>내용</th>
                            <td>
                                <tiptapTextEditor ref="textEditor" :modCond="pageType == 'modify'"/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
          
        </div>

        <div class="modal-footer" v-if="pageType == 'detail'">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">닫기</button>
          <button type="button" v-if="deleteAuth" class="btn btn-primary" data-bs-dismiss="modal" @click="changePageType('modify')" >수정</button>
        </div>
        <div class="modal-footer" v-else >
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="changePageType('detail')">취소</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="updateNotification()" :disabled="dateCheck() && changeTime">저장</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import axios from "@/composables/Axios";
import tachoEntity from "@/entity/TachoEntity";
import Entity from "@/entity/OperationEntity";
import {tiptapTextEditor} from "@/components/tacho/component/index";
import {
  changeFormat
} from '@/components/tacho/common/CommonFunc';

const url = tachoEntity.baseUrl;
const store = useStore();
const operationUrl = store.state['api'].operationUrl;
const entity = new Entity.organizationHeaders(store.state.sign['userInfo'].userId);
const header = entity.get();
const showRegionList = ref(false);
const textEditor = ref();

const props = defineProps({
  regionList: Object,
  noti_no: Number,
  deleteAuth: Boolean,
})

const notiGetResult = ref({});
const resultParams = ref({});

const pageType = ref("detail");

const timeOut = ref("");
const changeTime = ref(false);

const emit = defineEmits(['close', 'refreash']);

const checkedItemList = new Map();
const changeChecked = (checked, area) => {
    if (checked === true) {
        checkedItemList.set(area, area)
    } else {
        checkedItemList.delete(area)
    }

    document.getElementById('selectAll').checked = (checkedItemList.size == props.regionList.length);
}
const changeCheckedAll = (checked) => {
    let childList = document.getElementById('region_list').children;

    for(let i = 1 ; i < childList.length ; i++) {
        childList[i].children[0].checked = checked;
        changeChecked(checked, childList[i].children[0].value);
    }
}
function toggleRegionList() {
  showRegionList.value = !showRegionList.value
}

const updateNotification = async () => {
    if(resultParams.value.title == undefined || resultParams.value.title == "") {
        alert('제목을 입력하세요');
        return;
    }
    if(resultParams.value.postEdDay == undefined) {
        alert('게시 기간을 입력하세요');
        return;
    }
    if(checkedItemList.size == 0) {
        alert('지역을 선택하세요');
        return;
    }

    let params = {};

    params.no = notiGetResult.value.appNoticeInfoDto.no;
    params.title = resultParams.value.title;
    params.postEdDay = changeFormat(resultParams.value.postEdDay, 'YYYY-MM-DDTHH:mm:ss');
    params.content = textEditor.value.getTextHtml();
    params.position = "";

    if( params.content == "<p></p>" ) {
        alert('내용을 입력하세요.');
        return;
    }

    let areaList = [];
    checkedItemList.forEach((value, key) => {
        areaList.push(value);
    })
    params.areaList = areaList;
    const res = await axios.$put(`${url}notice`, params, {headers: header});

    emit('refreash');
    emit('close');
}

const getDetailData = async () => {
  try {
    const res = await axios.$get(`${url}notice?no=` + props.noti_no, {}, header);

    notiGetResult.value = res.data.data;
    notiGetResult.value.appNoticeInfoDto.postEdDay = changeFormat(notiGetResult.value.appNoticeInfoDto.postEdDay, 'YYYY-MM-DDTHH:mm:ss');

    settingData();
    
  } catch (error) {
    store.commit("openMessageBox", error);
  }
}

const settingData = () => {
  resultParams.value.title = notiGetResult.value.appNoticeInfoDto.title;
  resultParams.value.postEdDay = notiGetResult.value.appNoticeInfoDto.postEdDay;
  textEditor.value.setText(notiGetResult.value.appNoticeInfoDto.content);

  for( let element of notiGetResult.value.appNoticeAreaList ) {
    document.getElementsByName(element.area)[0].checked = true;
    changeChecked(true, element.area);
  }
}

const changePageType = (insertType) => {
  pageType.value = insertType;


  if( insertType == 'detail' ) {
    changeCheckedAll(false);
    settingData();
    textEditor.value.setEditable(false);
    changeTime.value = false;
  }
  else {
    textEditor.value.setEditable(true);
  }
}

const dateCheck = () => {
    let result = false;
    result = timeOut.value > changeFormat(resultParams.value.postEdDay, 'YYYY-MM-DDTHH:mm:00');

    return result;
}

const init = () => {
  let today = new Date();
  today.setMinutes(today.getMinutes()+30);
  timeOut.value = changeFormat( today, 'YYYY-MM-DDTHH:mm:00');
  
  document.getElementById("postEdDay").min = timeOut.value;

  textEditor.value.setEditable(false);
  getDetailData();
}

onMounted(async () => {
    init();
})
/*
watch( ()=>resultParams.value.postEdDay, (_new, _odd)=>{
  changeTime.value = true;
} )
*/
</script>

<style scoped>
.region-list-wrapper {
  position: relative;
}

.region-list {
  margin-top: 5px;
  padding: 10px;
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  background: #fafafa;
}
</style>